const parseCoverage = (cov, covObj, uniqueCoverages) => {
    if (cov.selected === true) {
        covObj[cov.publicID] = cov;
        covObj[cov.publicID].vehicleCovCostsByID = {};
        covObj[cov.publicID].terms =  cov.terms.filter((term)=>!term.name.includes("Coverage Is")) 
        
        if (!!cov.vehicleCovCosts_ML) {
            cov.vehicleCovCosts_ML.forEach((vehicleCovCost) => {
                if (!!vehicleCovCost) {
                    covObj[cov.publicID].vehicleCovCostsByID[vehicleCovCost.vehiclePublicID] = vehicleCovCost.cost;
                }
            });
        }
        if (!uniqueCoverages.find((c) => c.publicID === cov.publicID)) {
            uniqueCoverages.push(cov);
        }
    }
};

const filterSelected = (array) => array.filter((cov) => cov.selected === true);

const getIncludedFeatures = (obj, property) => {
    if (obj[property]) {
        return filterSelected(obj[property]);
    }
    return [];
};


const getPUPVehicleDisplayName = (exposure) => {
    let name = `${exposure.year} ${exposure.make} ${exposure.model}`;
    if (exposure.trim_ML) {
        name += ` ${exposure.trim_ML}`;
    }
    return name;
};

export default {
    getVehicleCoverages: (personalAuto) => {
        const uniqueCoverages = [];
        const vehicleCoveragesByID = {};
        const lineCoverages = [];
        const lineCoveragesByID = {};
        personalAuto.lineCoverages.forEach((cov) => parseCoverage(cov, lineCoveragesByID, lineCoverages));
        personalAuto.vehicleCoverages.forEach((vehCov) => {
            vehicleCoveragesByID[vehCov.publicID] = {};
            vehCov.coverages.concat(personalAuto.optionalCoverages_ML).forEach((cov) => parseCoverage(cov, vehicleCoveragesByID[vehCov.publicID], uniqueCoverages));
        });

        return {lineCoverages, lineCoveragesByID, uniqueCoverages, vehicleCoveragesByID};
    },
    getIncludedFeatures: (lobs) => {
        let lob;
        if (lobs.personalAuto) {
            lob = lobs.personalAuto;
        } else if (lobs.homeowners) {
            lob = lobs.homeowners;
        }
        if (lob) {
            let result = [];
            result = result.concat(getIncludedFeatures(lob, 'additionalCoverages'));
            result = result.concat(getIncludedFeatures(lob, 'additionalCoverages_ML'));
            result = result.concat(getIncludedFeatures(lob, 'lineCoverages'));
            if (lob.vehicleCoverages) {
                // eslint-disable-next-line no-return-assign
                lob.vehicleCoverages.forEach((vehCov) => result = result.concat(getIncludedFeatures(vehCov, 'coverages')));
            }
            return result;
        }
    },
    getExclusions: (lobs) => {
        if (lobs.personalAuto) {
            return filterSelected(lobs.personalAuto.exclusionCoverages_ML);
        }
        if (lobs.homeowners) {
            return filterSelected(lobs.homeowners.exclusionCoverages_ML);
        }
    },
    getPUPOptionalCoverages: (lob, viewModelService) => {
        if (lob.additionalCoverages && lob.additionalCoverages.length > 0) {
            const result = [];
            filterSelected(lob.additionalCoverages).forEach((cov) => {
                switch (cov.code_ML) {
                    case 'PUPAssistedLivingCareLiabilityCov_ML':
                        const term = cov.terms.find((t) => t.patternCode === 'zeuj0a494nlcg3pn9qe8vlbqt09');
                        if (term) {
                            result.push({
                                name: cov.name,
                                value: [term.chosenTermValue]
                            });
                        }
                        break;
                    case 'PUPExcessBusinessPursuitsCov_ML':
                        if (cov.scheduledItems_ML?.businessActivities) {
                            result.push({
                                name: cov.name,
                                value: cov.scheduledItems_ML.businessActivities.map((act) => {
                                    return act.name;
                                })
                            });
                        }
                        break;
                    case 'PUPExcessIncidentalOccupancyCov_ML':
                        if (cov.scheduledItems_ML?.businessActivities) {
                            result.push({
                                name: cov.name,
                                value: cov.scheduledItems_ML.businessActivities.map((act) => {
                                    return act.name;
                                })
                            });
                        }
                        break;
                    case 'PUPLocalDeliveryCov_ML':
                        if (cov.selected) {
                            const hours = cov.terms.find((t) => t.patternCode === 'zssjejlnhe3k04h9e79phr5qc68');
                            const types = cov.terms.filter((t) => t.chosenTerm === 'true');
                            const nameList = [];
                            types.forEach(t => nameList.push(t.name));
                            const covValue = nameList.length < 1 ? hours.chosenTermValue : nameList.join(', ').concat('; ').concat(hours.chosenTermValue);
                            result.push({
                                name: cov.name,
                                value: [covValue]
                            });
                        }
                        break;
                    case 'PUPMotorVehicleFollowingFormCov_ML':
                        result.push({
                            name: cov.name,
                            value: ['--']
                        });
                        break;
                    case 'PUPRideShareCov_ML':
                        const hoursTerm = cov.terms.find((t) => t.patternCode === 'zhdgcpgqrmtbu9ejs6n8bb4vk7a');
                        result.push({
                            name: cov.name,
                            value: [hoursTerm.chosenTermValue]
                        });
                        break;
                    default:
                }
            });
            return result;
        }
    },
    getPUPExclusions: (lob) => {
        const result = [];
        if (lob.liabilityExclusions && lob.liabilityExclusions.length > 0) {
            filterSelected(lob.liabilityExclusions).forEach((cov) => {
                switch (cov.code_ML) {
                    case 'PUPWatercraftExclusion_ML':
                    case 'PUPRecreationalVehicleExclusion_ML':
                    case 'PUPMotorcycleExclusion_ML':
                        result.push({
                            name: cov.name,
                            value: ['--']
                        });
                        break;
                    case 'PUPDesignatedMotorVehicleRecreationVehicleOrWatercraftExclusion_ML':
                        let excluded = [];
                        if (cov.scheduledItems_ML?.excludedWatercrafts.length > 0) {
                            excluded = excluded
                                .concat(cov.scheduledItems_ML.excludedWatercrafts
                                    .map((w) => getPUPVehicleDisplayName(w)));
                        }
                        if (cov.scheduledItems_ML?.motorVehicles.length > 0) {
                            excluded = excluded
                                .concat(cov.scheduledItems_ML.motorVehicles
                                    .map((w) => getPUPVehicleDisplayName(w)));
                        }
                        if (cov.scheduledItems_ML?.recreationalExcludedVehicles.length > 0) {
                            excluded = excluded
                                .concat(cov.scheduledItems_ML.recreationalExcludedVehicles
                                    .map((w) => getPUPVehicleDisplayName(w)));
                        }
                        if (excluded.length > 0) {
                            result.push({
                                name: cov.name,
                                value: excluded
                            });
                        }
                        break;
                    case 'PUPDesignatedLocationExclusion_ML':
                        if (cov.scheduledItems_ML?.excludedLocations.length > 0) {
                            result.push({
                                name: cov.name,
                                value: cov.scheduledItems_ML.excludedLocations
                                    .map((loc) => `${loc.address.addressLine1}, ${loc.address.city}, ${loc.address.state} ${loc.address.postalCode}`)
                            });
                        }
                        break;
                    case 'PUPDesignatedPrivateStructureExclusion_ML':
                        if (cov.terms.length > 0) {
                            const description = cov.terms.find((term) => term.codeIdentifier_ML === 'PUPDesignatedPrivateStructureExclusionDescription_ML').chosenTermValue;
                            const addressLine1 = cov.terms.find((term) => term.codeIdentifier_ML === 'PUPDesignatedPrivateStructureExclusionAddressLine1_ML').chosenTermValue;
                            const city = cov.terms.find((term) => term.codeIdentifier_ML === 'PUPDesignatedPrivateStructureExclusionCity_ML').chosenTermValue;
                            const state = cov.terms.find((term) => term.codeIdentifier_ML === 'PUPDesignatedPrivateStructureExclusionState_ML').chosenTermValue;
                            const zip = cov.terms.find((term) => term.codeIdentifier_ML === 'PUPDesignatedPrivateStructureExclusionZip_ML').chosenTermValue;
                            result.push({
                                name: cov.name,
                                value: [`${description} ${addressLine1}, ${city}, ${state} ${zip}`]
                            });
                        }
                        break;
                    case 'PUPNamedDriverExclusion_ML':
                        if (cov.scheduledItems_ML?.excludedNamedDrivers){
                            result.push({
                                name: cov.name,
                                value: cov.scheduledItems_ML.excludedNamedDrivers.map((driver) => driver.contact.displayName)
                            });
                        }
                        break;
                    default:
                }
            });
        }
        if (lob.additionalCoverages && lob.additionalCoverages.length > 0) {
            const animalExclusion = filterSelected(lob.additionalCoverages).find((cov) => cov.code_ML === 'PUPAnimalLiabilityExclusionCov_ML');
            if (animalExclusion) {
                result.push({
                    name: animalExclusion.name,
                    value: [animalExclusion.terms.map((term) => term.chosenTermValue).join(', ')]
                });
            }
        }
        return result;
    },
    getPUPULCoverages: (lob) => {
        let result = [];
        if (lob.ulPolicyCoverages && lob.ulPolicyCoverages.length > 0) {
            lob.ulPolicyCoverages.forEach((ulPolicy) => {
                result = result.concat(ulPolicy.coverages);
            });
        }
        return result;
    }
};
